/**
 * ParLinx gallery — chip-filtered masonry painted from the JSON payload in
 * snippets/plx-gallery-data.liquid. Classic IIFE on purpose: the storefront
 * CSP + auto-injected es-module-shims break ES modules between theme assets.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-plx-gallery]');
  var dataEl = document.querySelector('[data-plx-gallery-data]');
  if (!root || !dataEl) return;

  var grid = root.querySelector('[data-plx-gallery-grid]');
  var moreBtn = root.querySelector('[data-plx-gallery-more]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-plx-chip]'));
  if (!grid) return;

  var items;
  try {
    items = JSON.parse(dataEl.textContent);
  } catch (err) {
    return;
  }

  var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 24;
  var doShuffle = root.getAttribute('data-shuffle') === 'true';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = { chip: 'all', page: 1 };

  /* Stable per-chip order: string-hash seed + mulberry32, so a colorway keeps
     the same (but non-alphabetical) arrangement across visits. */
  function seededShuffle(arr, seedStr) {
    var seed = 0;
    for (var i = 0; i < seedStr.length; i++) {
      seed = (seed * 31 + seedStr.charCodeAt(i)) >>> 0;
    }
    var rand = function () {
      seed = (seed + 0x6d2b79f5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
    var a = arr.slice();
    for (var j = a.length - 1; j > 0; j--) {
      var k = Math.floor(rand() * (j + 1));
      var tmp = a[j];
      a[j] = a[k];
      a[k] = tmp;
    }
    return a;
  }

  function filtered() {
    var list = state.chip === 'all'
      ? items
      : items.filter(function (it) { return it.c === state.chip; });
    return doShuffle ? seededShuffle(list, state.chip) : list;
  }

  function makeTile(it, stagger, eager) {
    var fig = document.createElement('figure');
    fig.className = 'plx-tile';
    var img = document.createElement('img');
    img.src = it.m;
    img.srcset = it.s + ' 480w, ' + it.m + ' 900w, ' + it.l + ' 1600w';
    img.sizes = '(min-width: 1100px) 25vw, (min-width: 720px) 33vw, 50vw';
    img.alt = it.a;
    img.width = it.w;
    img.height = it.h;
    img.loading = eager ? 'eager' : 'lazy';
    img.decoding = 'async';
    fig.appendChild(img);
    if (!reduced) {
      fig.style.transitionDelay = Math.min(stagger * 40, 480) + 'ms';
    }
    return fig;
  }

  function paint(append) {
    var list = filtered();
    var upTo = Math.min(state.page * pageSize, list.length);
    var start = append ? grid.children.length : 0;
    if (!append) grid.innerHTML = '';
    var frag = document.createDocumentFragment();
    for (var i = start; i < upTo; i++) {
      frag.appendChild(makeTile(list[i], i - start, !append && i < 4));
    }
    grid.appendChild(frag);
    if (moreBtn) moreBtn.hidden = upTo >= list.length;
    /* double rAF so freshly inserted tiles transition from their initial state */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(grid.children, function (el) {
          el.classList.add('is-in');
        });
      });
    });
  }

  function switchChip(chip) {
    if (chip === state.chip) return;
    state.chip = chip;
    // let page-level listeners (floating shop bar) follow the colorway;
    // 'all' is a filter reset, not a colorway pick
    if (chip !== 'all') {
      document.dispatchEvent(
        new CustomEvent('plx:colorway', { detail: { key: chip } })
      );
    }
    state.page = 1;
    chips.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-plx-chip') === chip));
    });
    if (reduced) {
      paint(false);
      return;
    }
    grid.classList.add('is-out');
    window.setTimeout(function () {
      grid.classList.remove('is-out');
      paint(false);
    }, 260);
  }

  chips.forEach(function (b) {
    b.addEventListener('click', function () {
      switchChip(b.getAttribute('data-plx-chip'));
    });
  });
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      state.page += 1;
      paint(true);
    });
  }

  paint(false);
})();
